import { LuLock } from "react-icons/lu";

import { CollectionIcon } from "@/components/shared/collection-icon";
import { TimestampTooltip } from "@/components/shared/timestamp-tooltip";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { CollectionMeta } from "@/hooks/use-collections";
import { pluralize } from "@/utils/helpers";

import { CollectionCardManageButton } from "./collection-card-manage-button";

interface CollectionCardProps {
  collection: CollectionMeta;
  isOwner: boolean;
}

export function CollectionCard({ collection, isOwner }: CollectionCardProps) {
  return (
    <Card
      className="
        flex h-full cursor-pointer flex-col overflow-hidden rounded-2xl border
        bg-transparent
        hover:border-primary hover:bg-accent
      "
    >
      <CardHeader className="p-4">
        <div className="mb-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CollectionIcon
              type={collection.type}
              className="size-4 text-muted"
            />
            {collection.private && <LuLock className="size-4 text-muted" />}
            <span className="text-xs text-muted capitalize">
              {collection.type}
            </span>
          </div>
          {isOwner && collection.id && (
            <CollectionCardManageButton collectionId={collection.id} />
          )}
        </div>
        <CardTitle
          className="
            line-clamp-2 font-sans text-sm text-balance wrap-break-word
            text-muted-foreground
          "
        >
          {collection.name}
        </CardTitle>
        <CardDescription
          className="
          line-clamp-2 text-xs/5 wrap-break-word text-muted
        "
        >
          {collection.description}
        </CardDescription>
      </CardHeader>
      <CardFooter
        className="
        unforce-radius mt-auto border-t p-4 pt-4 text-xs text-muted
      "
      >
        <div className="flex w-full justify-between">
          <span className="text-muted">
            {pluralize(collection.items.length, "item")}
          </span>
          <span className="text-muted">
            <TimestampTooltip
              timestamp={collection.updatedAt}
              leadingText="Updated"
            />
          </span>
        </div>
      </CardFooter>
    </Card>
  );
}
